<div class="modol_comp" *ngIf="data?.phoneNumber; else video">
    <div class="modal-header pb-0 pt-0 d-flex">
        <button class="button-close" mat-button [mat-dialog-close]="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
            </svg>
        </button>
    </div>
    <div class="modal-body pt-0">
        <h2 class="text-center"> {{data?.title }}</h2>
        <app-filter-data [fromSms]="true" (filterSelection)="filterSelection($event)">
        </app-filter-data>
        <div class="client-list" (scroll)="onWindowScroll($event)">
            <!-- <div class="alert alert-warning"  role="alert">
                <strong>Sorry!</strong> No record found!.
            </div> -->
            <div *ngIf="totalCounts>0 else noDataFound" class="table-responsive">
                <table class="table ">
                    <thead class="p-2">
                        <tr>
                            <th scope="col">Company Logo</th>
                            <th scope="col">Company Name</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let client of clientList">
                            <td><img style="width: 52px;height: 52px;"
                                    [src]="client['logo']  || 'assets/images/person.svg'" /></td>
                            <td>{{client['name']}}</td>
                            <td>
                                <img (click)="addPhoneNumber(client)" class="ps-2 mb-1 hand-icon"
                                    src="assets/images/add_circle_outline.png" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ng-template #noDataFound>
                <div class="no-data-found">No Client Found</div>
            </ng-template>
        </div>
    </div>
</div>

<ng-template #video>
    <div class="modol_comp d-flex flex-column h-100">
        <div class="modal-header pb-0 pt-0 d-flex">
            <button class="button-close" mat-button [mat-dialog-close]="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
                </svg>
            </button>
        </div>
        <div class="modal-body pt-0">
            <h2 class="text-center"> {{data?.title }}</h2>
            <!-- <app-filter-data [fromSms]="true" (filterSelection)="filterSelection($event)">
            </app-filter-data> -->
            <div class="video-list">
                <!-- <div class="alert alert-warning"  role="alert">
                <strong>Sorry!</strong> No record found!.
            </div> -->
                <div *ngIf="totalCounts>0 else noDataFound" class="table-responsive scroll-hide" cdkScrollable
                    style="max-height: calc(100vh - 300px); overflow-y: auto;">
                    <table class="table " style="cursor: grab;">
                        <thead class="p-2">
                            <tr>
                                <th scope="col" width="10% !important">Order</th>
                                <th scope="col" width="10% !important">Thumbnail URL</th>
                                <th scope="col" width="40% !important">Title</th>
                                <th scope="col" width="40% !important">Description</th>
                            </tr>
                        </thead>
                        <tbody class="example-list" cdkDropList #essentialList="cdkDropList" [cdkDropListData]="video"
                            (cdkDropListDropped)="dropEstimate($event,1)">
                            <tr *ngFor="let video of data?.video; let i = index" cdkDrag>
                                <td>{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
                                <td><img style="width: 52px;height: 52px;border-radius:50%"
                                        [src]="video['thumbnailUrl']  || 'assets/images/person.svg'" /></td>
                                <td class="description">{{video['title']}}</td>
                                <td class="description"  matTooltipPosition="below" [matTooltip]="video?.description" >{{ video?.description.length > 60 ?
                                    video?.description.slice(0, 60) + '...' : video?.description }}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <ng-template #noDataFound>
                    <div class="no-data-found">No Client Found</div>
                </ng-template>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn cancel" [mat-dialog-close]="false">Cancel</button>
            <!-- <button type="submit" class="btn delete-btn" *ngIf="data.type==2">Delete</button> -->
            <button type="submit" class="btn delete" (click)="saveVideoOrder()">{{'Save'}}</button>
        </div>

    </div>
</ng-template>